import React, {useState} from "react";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import GeneralUtils from "../../../../../utils/GeneralUtils";
import {toast} from "react-toastify";

const defaultLecture = {
    title: '',
    externalUrl: ''
}
const ExternalUrlForm = (props) => {
    const {index, cancel, save} = props;
    const [data, setData] = useState(!GeneralUtils.isNullOrEmpty(props.data) ? props.data : defaultLecture);

    const handleSave = () => {
        if (GeneralUtils.isNullOrEmpty(data.title) || GeneralUtils.isNullOrEmpty(data.externalUrl)) {
            return toast.warn('Lütfen tüm alanlarını doldurun.');
        }
        const dataToSave = {
            ...data,
            description: data.description?.trim() === '' ? null : data.description
        };
        save(dataToSave);
    }


    const handleChange = (e) => {
        const value = e.target.value;
        setData({...data, [e.target.name]: value});
    }

    return (
        <div className="flex flex-column gap-2">
            <div className="flex flex-column gap-2">
                <p style={{minWidth: "50px", fontWeight: "600"}}>Başlık</p>
                <InputText name="title" type="text" value={data.title} onChange={handleChange}
                           className="inputtext p-inputtext-sm" placeholder="Açıklayıcı Başlık"/>
            </div>

            <div className="flex flex-column gap-2">
                <p style={{minWidth: "50px", fontWeight: "600"}}>URL</p>
                <InputText name="externalUrl" type="text" value={data.externalUrl} onChange={handleChange}
                           className="inputtext p-inputtext-sm" placeholder="https://www.example.com"/>
            </div>

            <div className="flex justify-content-end gap-2">
                <Button label="İptal" onClick={cancel} outlined size="small"/>
                <Button label="Kaydet" onClick={handleSave} raised size="small"/>
            </div>
        </div>
    )
};

export default ExternalUrlForm;
